module.exports = __webpack_public_path__ + "static/media/Yoyo_5913.a54c2c40.jpg";